import { useSearchParams, useNavigate } from 'react-router-dom'
import { CheckCircle2, MessageSquare, ArrowLeft } from 'lucide-react'

export default function PaymentSuccessPage() {
  const [params] = useSearchParams()
  const navigate = useNavigate()
  const orgId = params.get('orgId') ?? ''
  const connectUrl = params.get('connectUrl') ?? ''

  return (
    <div className="min-h-screen flex items-center justify-center px-4" style={{ background: '#0f1117' }} dir="rtl" lang="he">
      <div className="w-full max-w-lg text-center">
        <div
          className="w-20 h-20 rounded-full flex items-center justify-center mx-auto mb-6"
          style={{ background: '#10b98120', border: '2px solid #10b98150' }}
        >
          <CheckCircle2 size={44} style={{ color: '#4ade80' }} />
        </div>

        <h1 className="text-2xl sm:text-3xl font-extrabold text-white mb-3">
          התשלום התקבל בהצלחה!
        </h1>

        {orgId && (
          <p className="text-sm mb-2" style={{ color: '#9ca3af' }}>
            החשבון שלך הופעל. מספר הארגון שלך:{' '}
            <span className="font-mono text-white">{orgId}</span>
          </p>
        )}

        <p className="text-sm mb-8" style={{ color: '#6b7280' }}>
          בקרוב תקבל גם גישה ל-JumpStart Hub לניהול מלא
        </p>

        {connectUrl && (
          <a
            href={connectUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 px-8 py-3.5 rounded-xl font-bold text-white transition-transform hover:scale-[1.02]"
            style={{ background: '#10b981', boxShadow: '0 4px 24px rgba(16,185,129,0.3)' }}
          >
            <MessageSquare size={20} />
            חבר את ה-WhatsApp שלך
          </a>
        )}

        <div className="mt-6">
          <button
            onClick={() => navigate('/whatsapp/pricing')}
            className="inline-flex items-center gap-1.5 text-sm transition-colors"
            style={{ color: '#6b7280' }}
          >
            <ArrowLeft size={14} />
            חזרה לדף המחירים
          </button>
        </div>
      </div>
    </div>
  )
}
